import React from 'react'
import { Box, Typography, Radio, FormControlLabel } from '@applift/factor'
import { Select } from 'factor'

import { useDurationOptions } from '../../../hooks/usePixel'
import { Action, PixelInfo } from '../../../models/Pixel'
import {
  DEFAULT_VALUES,
  MAX_REPEATED_SETTING_VALUES,
} from '../../../constants/constants'

export interface RepeatedConversionProps {
  dispatch: React.Dispatch<Action>
  data: PixelInfo
}

export const RepeatedConversionSetting = (props: RepeatedConversionProps) => {
  const { data, dispatch } = props

  const { conversionSetting } = data

  const { data: durationOptions } = useDurationOptions()

  return (
    <>
      <Typography component="h5" variant="bodySmall" weight="demi">
        Repeat Conversions
      </Typography>
      <Typography
        sx={{
          textColor: 'neutral-500',
        }}
      >
        Repeat conversion settings allow for multiple conversions from the same
        user to be tracked and attributed to the same ad or campaign.
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <FormControlLabel
          checked={
            conversionSetting.repeatConversion.count ===
            DEFAULT_VALUES.CONVERSION_COUNT
          }
          onChange={() =>
            dispatch({
              type: 'UPDATE_REPEAT_CONVERSION',
              payload: {
                count: DEFAULT_VALUES.CONVERSION_COUNT,
                frequency: DEFAULT_VALUES.CONVERSION_FREQUENCY,
                unit: DEFAULT_VALUES.CONVERSION_UNIT,
              },
            })
          }
          control={<Radio size="medium" />}
          labelPlacement="end"
          label="Count all conversions per user"
        />

        <FormControlLabel
          checked={
            conversionSetting.repeatConversion.count !==
              DEFAULT_VALUES.CONVERSION_COUNT &&
            conversionSetting.repeatConversion.frequency ===
              DEFAULT_VALUES.CONVERSION_FREQUENCY
          }
          onChange={() =>
            dispatch({
              type: 'UPDATE_REPEAT_CONVERSION',
              payload: {
                count: 1,
                frequency: DEFAULT_VALUES.CONVERSION_FREQUENCY,
                unit: DEFAULT_VALUES.CONVERSION_UNIT,
              },
            })
          }
          control={<Radio size="medium" />}
          labelPlacement="end"
          label="Count 1 conversion per user"
        />
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <FormControlLabel
            checked={
              conversionSetting.repeatConversion.count !==
                DEFAULT_VALUES.CONVERSION_COUNT &&
              conversionSetting.repeatConversion.frequency !==
                DEFAULT_VALUES.CONVERSION_FREQUENCY
            }
            onChange={() =>
              dispatch({
                type: 'UPDATE_REPEAT_CONVERSION',
                payload: {
                  count: 1,
                  frequency: 1,
                  unit: DEFAULT_VALUES.CONVERSION_UNIT,
                },
              })
            }
            control={<Radio size="medium" />}
            labelPlacement="end"
            label="Count 1 conversions per user every"
          />
          <Select
            options={Array.from(
              {
                length: (conversionSetting.repeatConversion.unit === 'Day'
                  ? MAX_REPEATED_SETTING_VALUES.Day
                  : MAX_REPEATED_SETTING_VALUES.Hour) as number,
              },
              (_, i) => i + 1
            ).map(item => ({ label: item.toString(), value: item }))}
            isReadOnly={
              !(
                conversionSetting.repeatConversion.count !==
                  DEFAULT_VALUES.CONVERSION_COUNT &&
                conversionSetting.repeatConversion.frequency !==
                  DEFAULT_VALUES.CONVERSION_FREQUENCY
              )
            }
            onChange={(option: { label: string; value: string }) =>
              dispatch({
                type: 'UPDATE_REPEAT_CONVERSION',
                payload: { frequency: Number(option.value) },
              })
            }
            showLabelAlways
            value={{
              value: conversionSetting.repeatConversion.frequency,
              label: conversionSetting.repeatConversion.frequency.toString(),
            }}
            isNaked
            underline
          />
          <Select
            options={durationOptions ?? []}
            isReadOnly={
              !(
                conversionSetting.repeatConversion.count !==
                  DEFAULT_VALUES.CONVERSION_COUNT &&
                conversionSetting.repeatConversion.frequency !==
                  DEFAULT_VALUES.CONVERSION_FREQUENCY
              )
            }
            onChange={(option: { label: string; value: string }) =>
              dispatch({
                type: 'UPDATE_REPEAT_CONVERSION',
                payload: { unit: option.value, frequency: 1 },
              })
            }
            showLabelAlways
            value={{
              value: conversionSetting.repeatConversion.unit,
              label: durationOptions?.find(
                item => item.value === conversionSetting.repeatConversion.unit
              )?.label,
            }}
            isNaked
            underline
          />
        </Box>
      </Box>
    </>
  )
}
